import { registerPromptLanguage } from "@/lib/prompt/monaco";
import { BeforeMount } from "@monaco-editor/react";

let createdTheme = false;
let createdPromptLanguage = false; // More of hijacking the 'mdx' language than creating a new one

/**
 * BeforeMount callback to be used with `@monaco-editor/react`'s `BeforeMount` prop.
 *
 * Registers theme and prompt language.
 */
export const beforeMount: BeforeMount = (monaco) => {
  if (!createdTheme) {
    monaco.editor.defineTheme("llama", {
      base: "vs",
      inherit: true,
      rules: [],
      // bg-oldgray-100
      colors: { "editor.background": "#fafafa" },
    });
    monaco.editor.defineTheme("llama-white", {
      base: "vs",
      inherit: true,
      rules: [],
      colors: { "editor.background": "#ffffff" },
    });
    createdTheme = true;
  }

  if (!createdPromptLanguage) {
    registerPromptLanguage(monaco);
  }
};
